import { render, staticRenderFns } from "./TaskTypes.vue?vue&type=template&id=12f65e01&scoped=true"
import script from "./TaskTypes.vue?vue&type=script&lang=js"
export * from "./TaskTypes.vue?vue&type=script&lang=js"
import style0 from "./TaskTypes.vue?vue&type=style&index=0&id=12f65e01&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f65e01",
  null
  
)

export default component.exports